import * as graphql from 'generated/graphql';

import SentimentDisplay from './SentimentDisplay';

export default function StarsDisplay(props: { item: graphql.EvaluationSubmissionItem }) {
	return (
		<SentimentDisplay
			item={props.item}
			suffix="stars"
			choices={['⭐', '⭐', '⭐', '⭐', '⭐']}
			accumulative
		/>
	);
}
